var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2LivingRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM21.12 32h33.79A2.07 2.07 0 0157 34.12v5.19c-2.67.51-4 2.86-4 5.68H23c0-2.81-1.31-5.16-3.91-5.68v-5.19A2.12 2.12 0 0121.12 32zM58 42a2.79 2.79 0 012.91.58c.483.37.833.885 1 1.47A3.09 3.09 0 0159 48v8h-4v-4H21v4h-4v-8a3.09 3.09 0 01-2.89-4 2.83 2.83 0 011-1.47A2.79 2.79 0 0118 42a3.1 3.1 0 012 2.92v3.1h36V45v-.1a3.1 3.1 0 012-2.9z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Living_Room.b4aaba1b.svg";
export { SvgE2LivingRoom as ReactComponent };